import api from './axios';

export const submitReview = (body) => api.post('/reviews', body).then((r) => r.data);

export const fetchMyReviews = (params) =>
  api.get('/reviews/mine', { params }).then((r) => r.data);

export const updateReview = (id, body) =>
  api.put(`/reviews/${id}`, body).then((r) => r.data);

export const deleteReview = (id) => api.delete(`/reviews/${id}`).then((r) => r.data);

export const fetchSalonReviews = (params) =>
  api.get('/salon/reviews', { params }).then((r) => r.data);

export const fetchSalonReviewSuggestions = (params) =>
  api.get('/salon/reviews/suggestions', { params }).then((r) => r.data);

export const replyToReview = (id, message) =>
  api.put(`/salon/reviews/${id}/reply`, { message }).then((r) => r.data);

export const setReviewVisibility = (id, isVisible) =>
  api.put(`/salon/reviews/${id}/visibility`, { isVisible }).then((r) => r.data);
